export default {"src":"/_next/static/media/Splunk.8190eb4c.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};